import axios from "axios";

axios.interceptors.response.use(

  (response) => response,

  (error) => {

    const code =
      error.response?.data?.code;

    if (

      code === "TOKEN_EXPIRED" ||

      code === "USER_DISABLED" ||

      error.response?.status === 401 ||

      error.response?.status === 403

    ) {

      const currentPath =
        window.location.pathname;

      if (
        currentPath !== "/login"
      ) {

       window.dispatchEvent(
          new CustomEvent(
            "session-expired"
          )
        );

      }

    }

    return Promise.reject(error);

  }

);

export default axios;